import { createI18n } from 'vue-i18n';
import cs from '@/locale/cs.json';
import de from '@/locale/de.json';
import en from '@/locale/en.json';
import es from '@/locale/es.json';
import fr from '@/locale/fr.json';
import it from '@/locale/it.json';

export const SUPPORTED_LOCALES = ['en', 'es', 'de', 'it', 'fr', 'cs'] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

export const LOCALE_OPTIONS: { value: SupportedLocale; caption: string }[] = [
  { value: 'en', caption: 'English' },
  { value: 'es', caption: 'Español' },
  { value: 'de', caption: 'Deutsch' },
  { value: 'it', caption: 'Italiano' },
  { value: 'fr', caption: 'Français' },
  { value: 'cs', caption: 'Český' },
];

export function isSupportedLocale(value: unknown): value is SupportedLocale {
  return typeof value === 'string' && (SUPPORTED_LOCALES as readonly string[]).includes(value);
}

export function browserLocale(): SupportedLocale {
  const code = (window.navigator.language || 'en').split('-')[0].toLowerCase();
  return isSupportedLocale(code) ? code : 'en';
}

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: browserLocale(),
  fallbackLocale: 'en',
  messages: { cs, de, en, es, fr, it },
});

export function applyLocale(locale: SupportedLocale): void {
  i18n.global.locale.value = locale;
  document.documentElement.lang = locale;
}

export default i18n;
